// export const mainBaseUrl = 'http://localhost:5173/';
// export const apiBaseUrl = 'http://localhost/my_projects/InvoicingAiTool/AiBusinessMangerAdmin/';

// export const mainBaseUrl = "https://ai-business-manger.vercel.app/";
export const mainBaseUrl = "https://app.julytoss.com/";
export const apiBaseUrl = 'https://api.julytoss.com/';

